import {Tooltip} from 'bootstrap';

window.initTooltip = function (item){
    let tooltip = new Tooltip(
        item,
        {
            placement: 'top',
            html: true,
        }
    )
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(window.initTooltip)
})